import { Component } from '@angular/core';

@Component({
  selector: 'app-ui-progressbar',
  templateUrl: './ui-progressbar.component.html',
  styleUrls: ['./ui-progressbar.component.css']
})
export class UiProgressbarComponent {
  /**
   * Header button list show
   */
  Settingicon = true;
  Menuoption = 'center'
}
